import { useEffect } from 'react';

const SITE = 'https://joinsahiri.com';
const DEFAULT_TITLE = 'Sahiri Amali | Know Yourself. Find Your People. Stay Safe.';
const DEFAULT_DESC = 'A safe space for self-discovery, built for the people the world keeps failing. Research-backed assessments, an AI companion, values-gated community. Free.';

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const [, key, name] = selector.match(/\[(name|property|rel)="([^"]+)"\]/) || [];
    if (key) el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/** Per-route <title>, description, canonical and share-card tags (audit D5.1). Optional `image` + `jsonLd`. */
export function usePageMeta({ title, description, path, image, imageAlt, jsonLd } = {}) {
  const jsonLdText = jsonLd ? JSON.stringify(jsonLd) : '';
  useEffect(() => {
    const fullTitle = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE}${path || window.location.pathname}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', 'content', desc);
    setMeta('link[rel="canonical"]', 'href', url);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', desc);
    setMeta('meta[name="twitter:url"]', 'content', url);
    if (image) {
      setMeta('meta[property="og:image"]', 'content', image);
      setMeta('meta[name="twitter:image"]', 'content', image);
      if (imageAlt) setMeta('meta[property="og:image:alt"]', 'content', imageAlt);
    }
  }, [title, description, path, image, imageAlt]);

  useEffect(() => {
    if (!jsonLdText) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.dataset.pageJsonld = 'true';
    el.text = jsonLdText;
    document.head.appendChild(el);
    return () => el.remove();
  }, [jsonLdText]);
}
